import routes from './routes';
import { SetRoutes } from 'components';

const RoomsMainPage = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default RoomsMainPage;
